// =========================================================
// ANIMATIONS — handler générique [data-anim] (GSAP + ScrollTrigger)
// Remplace AOS. Markup : <el data-anim="fade-up" data-delay="0.2"
//                              data-duration="0.8" data-start="top 85%"
//                              data-once="true">
//
// Règle d'or : gsap.set(état caché) puis gsap.to(état visible).
// JAMAIS gsap.from() (double animation au refresh).
// =========================================================
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ANIM, PRESETS } from "./anim_config";

gsap.registerPlugin( ScrollTrigger );

const animations = {
    "fade":      PRESETS.fadeIn,
    "fade-up":   PRESETS.fadeUp,
    "fade-down": { opacity: 0, y: -ANIM.yOffset.md },
    "fade-left": { opacity: 0, x: -ANIM.yOffset.md },
    "fade-right":{ opacity: 0, x: ANIM.yOffset.md },
    "zoom-in":   { opacity: 0, scale: 0.92 },
    "zoom-out":  { opacity: 0, scale: 1.08 },
    "blur-in":   { opacity: 0, filter: "blur(8px)" },
};

export function initDataAnim( scope = document ) {
    // Si le fallback anti-gel a déjà révélé le contenu (bundle lent), on N'ANIME PAS
    // les éléments concernés (sinon flash) : on les marque juste comme faits.
    const skip = typeof window !== "undefined" && window.__pdwAnimSkip;
    const els = scope.querySelectorAll( "[data-anim]:not(.is-animated)" );

    els.forEach( ( el ) => {
        if ( skip ) { el.classList.add( "is-animated" ); return; }

        const name     = el.dataset.anim;
        const delay    = parseFloat( el.dataset.delay )    || 0;
        const duration = parseFloat( el.dataset.duration ) || ANIM.duration.md;
        const start    = el.dataset.start || ANIM.start.section;
        const once     = el.dataset.once !== "false";

        const initial = animations[ name ];
        if ( ! initial ) return;

        gsap.set( el, initial );

        const final = {};
        Object.keys( initial ).forEach( ( k ) => {
            if ( k === "opacity" )      final[ k ] = 1;
            else if ( k === "scale" )   final[ k ] = 1;
            else if ( k === "filter" )  final[ k ] = "blur(0px)";
            else                        final[ k ] = 0; // x / y
        } );

        const play = () => {
            gsap.to( el, {
                ...final,
                duration,
                delay,
                ease: ANIM.ease.out,
                onComplete: () => el.classList.add( "is-animated" ),
                clearProps: "transform,opacity,filter",
            } );
        };

        // Déjà dans le viewport au load → on anime tout de suite.
        // Sinon → ScrollTrigger onEnter (un gsap.to avec scrollTrigger sur un
        // élément déjà dépassé "snappe" sans animer).
        const rect = el.getBoundingClientRect();
        if ( rect.top < window.innerHeight && rect.bottom > 0 ) {
            play();
        } else {
            ScrollTrigger.create( { trigger: el, start, once, onEnter: play } );
        }
    } );
}
